import React, { useState } from 'react'
import { Button, Form, InputGroup, Modal } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import { useTranslation } from 'react-i18next';

import plusIcon from '../../../assets/icons/plus-button.png';
import minusIcon from '../../../assets/icons/minus.png';

const FirmaRemotaCertificates = ({ parentState, onAuthorizeFirmaremotaCertificate, onUnauthorizeFirmaremotaCertificate, children }) => {
    const { t } = useTranslation();
    const {
        certificatesOrdered: { FirmaRemota },
        FirmaRemotaIsAuthorized
    } = parentState;

    const [showAuthorizeModal, setShowAuthorizeModal] = useState(false);
    
    const firmaRemotaColumns = [
        {
            dataField: 'certalias',
            text: t('certificates.certificate'),
            align: 'left',
            sort: true,
            headerAlign: 'left',
            headerClasses: 'headerClass1',
            style: { verticalAlign: 'middle' }
        },
        {
            dataField: 'ExpirationDate',
            text: t('certificates.certificate-date'),
            align: 'left',
            sort: true,
            headerAlign: 'left',
            headerClasses: 'headerClass2',
            style: { verticalAlign: 'middle' }
        }
    ];

    if (FirmaRemota.length === 0) {
        FirmaRemota.push({
            GUID: 'placeholder',
            certalias: '---',
            ExpirationDate: '---',
        })
    }

    const [FRuser, setFRuser] = useState('');
    const [FRpassword, setFRpassword] = useState('');
    
    return (
        <div className="table-container">
            <div className='table-container-header'>
                {
                    FirmaRemotaIsAuthorized ? (
                        <button
                            className="new-create-button"
                            onClick={onUnauthorizeFirmaremotaCertificate}
                        >
                            <img src={minusIcon} alt="minus icon" />
                            <span>{t("general.unauthorize")}</span>
                        </button>
                        ) : (
                        <button
                            className="new-create-button"
                            onClick={() => setShowAuthorizeModal(true)}
                        >
                            <img src={plusIcon} alt="plus icon" />
                            <span>{t("general.authorize")}</span>
                        </button>
                )}
                {FirmaRemotaIsAuthorized && children}
            </div>
            <Modal
                show={showAuthorizeModal}
                onHide={() => setShowAuthorizeModal(false)}
                >
                <Modal.Header closeButton>
                    <Modal.Title>{t("general.authorize")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <InputGroup className="mb-3">
                        <InputGroup.Prepend>
                            <InputGroup.Text
                                id="firma-remota-user">{t('general.user')}</InputGroup.Text>
                        </InputGroup.Prepend>
                        <Form.Control
                            required
                            type="text"
                            aria-label="Default"
                            aria-describedby="firma-remota-user"
                            value={FRuser}
                            onChange={e => setFRuser(e.target.value)}
                        />
                    </InputGroup>
                    <InputGroup className="mb-3">
                        <InputGroup.Prepend>
                            <InputGroup.Text
                                id="firma-remota-password">{t('general.password')}</InputGroup.Text>
                        </InputGroup.Prepend>
                        <Form.Control
                            required
                            type="password"
                            aria-label="Default"
                            aria-describedby="firma-remota-password"
                            value={FRpassword}
                            onChange={e => setFRpassword(e.target.value)}
                        />
                    </InputGroup>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        type="button"
                        id="authorizeFR"
                        className="btn btn-primary signature-image"
                        onClick={() => {
                            setShowAuthorizeModal(false);
                            onAuthorizeFirmaremotaCertificate({FRuser, FRpassword});
                        }
                        }>
                        {t('general.confirm')}
                    </Button>
                </Modal.Footer>
            </Modal>
            {
                FirmaRemotaIsAuthorized &&
                    <div>
                        <ToolkitProvider
                            keyField="GUID"
                            data={FirmaRemota}
                            columns={firmaRemotaColumns}
                        >
                            {
                                props => (
                                    <div>
                                        <BootstrapTable striped
                                            {...props.baseProps}
                                        />
                                    </div>
                                )
                            }
                        </ToolkitProvider>
                    </div>
            }
        </div>
    )
}

export default FirmaRemotaCertificates